import React, { FunctionComponent } from 'react';
import Style from './HR.style';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
}
export const HR: FunctionComponent<IProps> = (props) => <Style { ...props } />;
